import axios from 'axios'
import { API_BASE_URL } from '../globalVar'

export const appSettingsService = {
    getClaimPaymentsEnabled,
    getRunPipelinesEnabled
}

function getClaimPaymentsEnabled() {
    return axios.get(API_BASE_URL + '/api/admin/v1/appsettings/claimpaymentsenabled')
}

function getRunPipelinesEnabled() {
    return axios.get(API_BASE_URL + '/api/admin/v1/appsettings/runpipelinesenabled')
}
